function getApiEndpoint() {
  const origin = window.location.origin;
  if (origin.includes('localhost')) {
    return 'http://localhost:8080';
  } else {
      return origin;
  }
}

export default getApiEndpoint;